import type { ICreditAppHousingStatus } from '@makemydeal/dr-platform-types';

export const TITLE_OPTIONS = [
    { label: 'Mr', value: 'Mr' },
    { label: 'Mrs', value: 'Mrs' },
    { label: 'Ms', value: 'Ms' },
    { label: 'Dr', value: 'Dr' },
    { label: 'Prof', value: 'Prof' }
];

export const SUFFIX_OPTIONS = [
    { label: 'Sr', value: 'SR' },
    { label: 'Jr', value: 'JR' },
    { label: 'I', value: 'I' },
    { label: 'II', value: 'II' },
    { label: 'III', value: 'III' },
    { label: 'IV', value: 'IV' }
];

export const MARITAL_STATUS_OPTIONS = [
    { label: 'Single', value: 'Single' },
    { label: 'Married', value: 'Married' },
    { label: 'Divorced', value: 'Divorced' },
    { label: 'Widowed', value: 'Widowed' },
    { label: 'Unmarried', value: 'Unmarried' },
    { label: 'Separated', value: 'Separated' }
];

export const RELATIONSHIP_TO_THE_BUYER_OPTIONS = [
    { label: 'Spouse', value: 'Spouse' },
    { label: 'Relative', value: 'Relative' },
    { label: 'Registered Domestic Partner', value: 'RegisteredDomesticPartner' },
    { label: 'Civil Union', value: 'CivilUnion' },
    { label: 'Other', value: 'Other' }
];

export const CO_APPLICANT_TYPE_OPTIONS = [
    { label: 'Co-Signer', value: 'CoSigner' },
    { label: 'Guarantor', value: 'Guarantor' }
];

export const BUYER = 'buyer';
export const CO_BUYER = 'coBuyer';
export const BUYER_DETAILS = 'buyerDetails';
export const CO_BUYER_DETAILS = 'coBuyerDetails';
export const INSURANCE = 'insurance';
export const BUSINESS = 'Business';
export const BUSINESS_DETAILS = 'Business Details';
export const OTHER_INCOME_SOURCE_FIELD = 'financialInfo.otherIncomeSource';
export const OTHER_INCOME_FIELD = 'financialInfo.otherIncome';
export const BANK_NAME_FIELD = 'business.bankName';
export const BANK_CONTACT_NAME_FIELD = 'business.bankContactName';
export const BANK_ACCOUNT_NUMBER_FIELD = 'bankAccountNumber';
export const BANK_CONTACT_PHONE_FIELD = 'business.bankContactPhoneNumber';
export const PAY_FREQUENCY_FIELD = 'financialInfo.incomeFrequency';
export const EXPECTED_INCOME_FIELD = 'financialInfo.income';

export const EMPLOYER_ADDRESS_FIELD = 'currentEmployment.address.streetAddress';
export const EMPLOYER_CITY_FIELD = 'currentEmployment.address.city';
export const EMPLOYER_STATE_FIELD = 'currentEmployment.address.state';
export const EMPLOYER_ZIP_FIELD = 'currentEmployment.address.zip';

export const HOUSING_STATUS_FIELD = 'housingInfo.housingStatus';
export const MONTHLY_MORTGAGE_RENT_FIELD = 'housingInfo.mortgageOrRentAmount';
export const YEARS_AT_ADDRESS_FIELD = 'yearsAtCurrentAddress';
export const MONTHS_AT_ADDRESS_FIELD = 'monthsAtCurrentAddress';
export const PREVIOUS_ADDRESS_STREET_FIELD = 'previousAddress.streetAddress';
export const PREVIOUS_ADDRESS_STREET_2_FIELD = 'previousAddress.streetAddress2';
export const PREVIOUS_ADDRESS_CITY_FIELD = 'previousAddress.city';
export const PREVIOUS_ADDRESS_STATE_FIELD = 'previousAddress.state';
export const PREVIOUS_ADDRESS_ZIP_FIELD = 'previousAddress.zip';
export const PREVIOUS_ADDRESS_COUNTY_FIELD = 'previousAddress.county';
export const YEARS_AT_PREVIOUS_ADDRESS_FIELD = 'yearsAtPreviousAddress';
export const MONTHS_AT_PREVIOUS_ADDRESS_FIELD = 'monthsAtPreviousAddress';
export const FIELDS_TO_BE_TRIMMED = [
    'firstName',
    'lastName',
    'middleName',
    'county',
    'streetAddress',
    'streetAddress2',
    'city',
    'zip',
    'email',
    OTHER_INCOME_SOURCE_FIELD,
    PREVIOUS_ADDRESS_STREET_FIELD,
    PREVIOUS_ADDRESS_STREET_2_FIELD,
    PREVIOUS_ADDRESS_CITY_FIELD,
    PREVIOUS_ADDRESS_ZIP_FIELD,
    PREVIOUS_ADDRESS_COUNTY_FIELD,
    EMPLOYER_ADDRESS_FIELD,
    EMPLOYER_CITY_FIELD,
    EMPLOYER_ZIP_FIELD
];

export const HOUSING_STATUS_OPTIONS: { label: string; value: ICreditAppHousingStatus }[] = [
    { label: 'Mortgage', value: 'Mortgage' },
    { label: 'Rent', value: 'Rent' },
    { label: 'Family', value: 'Family' },
    { label: 'Own Outright', value: 'OwnOutRight' },
    { label: 'Military', value: 'Military' },
    { label: 'Other', value: 'Other' }
];

export const DRIVERS_LICENCE_MASK = '*********';
export const SSN_MASK = '*********';
export const STATE_SELECT_MASK = '**';
export const MASK_VALUE_DEFAULT = '**/**/****';

export const SSN_PATTERN = {
    guide: true,
    mask: [/./, /./, /./, '-', /./, /./, '-', /./, /./, /./, /./],
    pipe: undefined,
    unmask: ['-']
};

export const ADDRESS_SEPARATOR = ' ';

export const EMPLOYMENT_STATUS_OPTIONS = [
    { value: 'Employed', label: 'Employed' },
    { value: 'Unemployed', label: 'Unemployed' },
    { value: 'Retired', label: 'Retired' },
    { value: 'ActiveMilitary', label: 'Active Military' },
    { value: 'RetiredMilitary', label: 'Retired Military' },
    { value: 'SelfEmployed', label: 'Self Employed' },
    { value: 'Student', label: 'Student' },
    { value: 'Other', label: 'Other' }
];
export const PAY_FREQUENCY_OPTIONS = [
    { value: 'Weekly', label: 'Weekly' },
    { value: 'Biweekly', label: 'Bi-Weekly' },
    { value: 'Monthly', label: 'Monthly' },
    { value: 'Annually', label: 'Annually' }
];

export const CUSTOMER_INFORMATION_HEADER = 'Customer Information';
export const DEAL_CUSTOMER_HEADER = 'Deal Customer';
export const CO_BUYER_HEADER = 'Co-Buyer';
export const VALIDATION_BANNER_TITLE = 'Fix required fields to continue';
export const CREATE_BUSINESS_ERROR_BODY = 'Unable to convert this customer to business. Please try again.';
export const VALIDATION_BANNER_BODY =
    "Some updates can't be saved yet. Review the highlighted fields and correct the errors before continuing.";
export const ASYNC_ERROR_BANNER_BODY = 'There was a problem updating. Please try again.';
export const CONVERT_TO_BUSINESS_SOLD_CONTRACTED_ALERT_TITLE = 'Deal Locked';
export const CONVERT_TO_BUSINESS_SOLD_CONTRACTED_ALERT =
    'Deals marked as Sold or Contracted are locked. Converting to business is not allowed.';
export const CONTRACTING_ALERT_PREFIX = 'Cannot generate contract. Please fix the highlighted ';
export const CONTRACTING_ALERT_SUFFIX = ' details before continuing.';
export const CONTRACTING_ALERT_BUYER_LABEL = 'buyer';
export const CONTRACTING_ALERT_CO_BUYER_LABEL = 'Co-buyer';
export const CONTRACTING_ALERT_INSURANCE_LABEL = 'insurance';
export const TAX_ID_MASK = '*********';
export const CHECKING_ACCOUNT_NUMBER_MASK = '********************';

export const BUSINESS_TAX_ID_NUMBER_FIELD = 'business.taxIdNumber';
export const BUSINESS_TYPE_FIELD = 'business.businessType';
export const BUSINESS_ESTABLISHED_DATE_FIELD = 'business.businessEstablishedDate';
export const BUSINESS_NUMBER_OF_EMPLOYEES_FIELD = 'business.numberOfEmployees';
export const BUSINESS_STATE_OF_INCORPORATION_FIELD = 'business.stateOfIncorporation';
export const BUSINESS_FINANCIAL_STATEMENT_DESCRIPTION_FIELD = 'business.financialStatementDescription';

export const BUSINESS_TYPE_OPTIONS = [
    { label: 'Corporation', value: 'Corporation' },
    { label: 'LLC', value: 'LLC' },
    { label: 'Partnership', value: 'Partnership' },
    { label: 'Proprietor', value: 'Proprietor' },
    { label: 'Other', value: 'Other' }
];

export const FINANCIAL_STATEMENT_TYPE_OPTIONS = [
    { label: 'CPA-Audited', value: 'CPA-Audited' },
    { label: 'CPA-Reviewed', value: 'CPA-Reviewed' },
    { label: 'CPA-Compiled', value: 'CPA-Compiled' },
    { label: 'Income Tax', value: 'Income Tax' },
    { label: 'Borrower Prepared', value: 'Borrower Prepared' },
    { label: 'None', value: 'None' }
];
